import { Tab, Tabs } from "react-bootstrap";
import Veiculo from "./Veiculo";

export default function VeicTracao() {
    return (
        <Tabs defaultActiveKey="rodo_veiculo" id="tab-veictracao" className="mb-3">
            <Tab eventKey="rodo_veiculo" title="Dados do Condutor/Veículo" className="px-2">
                <Veiculo />
            </Tab>
        </Tabs>
    )
}